<form [formGroup]="form">
  <div class="mb-3">
    <label #subtitleLabel for="element" class="text-label">¿Cómo se llama la empresa para la que trabajas?</label>
    <div
      #inbox
      class="w-full h-10 flex justify-center items-center px-2 py-1 rounded-sm shadow-lg border border-blue-700 bg-white">
      <input #element type="text" class="w-full h-full border-none outline-none focus:ring-0 rounded px-3 py-2" id="element"
        formControlName="element" aria-describedby="elementHelp" (input)="filter($event)" (keydown.escape)="esc()"
        placeholder="Ej: Banco de Bogotá" (keydown)="makeInvalid()" (blur)="validateBlur()" />
    </div>
    
    @if (filtered && filtered.length > 0) {
    <ul id="list" class="max-h-[300px] relative overflow-y-scroll mt-2 bg-white border border-gray-200">
      @for (item of filtered; track $index) {
      <li class="list-group-item p-2 text-gray-500 hover:bg-gray-100 cursor-pointer" (click)="select(item.value, item.label)">
        {{ item.label }}
      </li>
      }
    </ul>
    }

    <!-- Mensaje de error actualizado -->
    @if (hasError()) {
      <div class="text-red-500 text-[10px] mt-1">
        Por favor selecciona un elemento de la lista
      </div>
    }
  </div>
</form>